import React from "react";
import { useI18n } from "@/lib/i18n";

export default function Highlights() {
  const { t } = useI18n();

  return (
    <section
      id="services"
      data-testid="highlights-section"
      className="relative py-16 md:py-20 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-10 max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#e52620]" />
            <span
              data-testid="highlights-eyebrow"
              className="text-[11px] uppercase tracking-[0.3em] text-zinc-400 font-bold font-mono"
            >
              {t.highlights.eyebrow}
            </span>
          </div>
          <h2
            data-testid="highlights-title"
            className="text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-white leading-[0.95] text-balance"
          >
            {t.highlights.title}
          </h2>
        </div>

        {/* Asymmetric grid: 2 large + 3 small */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {t.highlights.items.map((item, i) => {
            const isLarge = i === 0 || i === 2;
            return (
              <article
                key={i}
                data-testid={`highlight-card-${i}`}
                className={`group relative p-8 md:p-10 bg-[#0e0e0e] border border-white/10 hover:border-[#e52620]/40 rounded-xl transition-all duration-500 overflow-hidden ${
                  isLarge ? "md:col-span-7" : "md:col-span-5"
                }`}
              >
                <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#e52620]/0 group-hover:bg-[#e52620]/10 blur-3xl transition-colors duration-700" />
                <div className="relative">
                  <div className="text-[#e52620] font-mono font-black text-3xl tracking-tighter">
                    {item.tag}
                  </div>
                  <h3 className="mt-4 text-2xl md:text-3xl font-bold text-white tracking-tight leading-tight">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-zinc-400 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
